
export enum DynamicPriceApplicationTypeCd {
	DESTINATION = 'Destination',
	ORIGIN = 'Origin'}

